import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { createProvider, Step } from '../../../../../../shared/IFE/step/step/step';
import { UntypedFormBuilder } from '@angular/forms';
import { AnalyticsService } from '../../../../../../shared/modules/analytics/services/analytics.service';

@Component({
  selector: 'evc-quote-personal-details-remarks',
  providers: [createProvider(RemarksComponent)],
  templateUrl: './remarks.component.html',
  styleUrls: ['./remarks.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemarksComponent extends Step implements OnInit {
  readonly formName = 'evcQuote';
  readonly stepName = 'personal-details-remarks';
  constructor(fb: UntypedFormBuilder, analyticsService: AnalyticsService) {
    super(fb, analyticsService);
  }

  writeValue(value): void {
    super.writeValue(value ? { value } : null);
  }

  public navigate(): void {
    if (this.control.valid) {
      this.onTouch();
      this.valueChanges(this.control.get('value').value);
    }
    super.navigate();
  }

  protected buildForm() {
    this.control = this.fb.group({
      value: this.fb.control('', []),
    });
    this.subscribeToValueChanges(false);
  }
}
